<template>
	<div>
		<!--编辑 -->
		<el-dialog title="新增地级行政区" :visible.sync="dialog" @close="unShowClick()">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="地级行政区" prop="area_name" :label-width="formLabelWidth">
					<el-input v-model="addBody.area_name"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		regionsave,
		updateRoleEmployee,
		EmployeeDetail
	} from '@/api/area-manage'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					area_name: '',
					mobile: '',
					uuid: '',
					role_uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					area_name: [{
						required: true,
						message: '请输入地级行政区',
						trigger: 'blur'
					}, ],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, ]
				},
				weightList: [],
				weight: '',
				isEdit: false
			}
		},
		mounted() {},
		methods: {
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateRoleEmployee()
						} else {
							this.network().regionsave()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					regionsave: async () => {
						const {
							status,
							data
						} = await regionsave({
							area_name: this.addBody.area_name,
							parent_id: 0,
							level: 1
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateRoleEmployee: async () => {
						const {
							status
						} = await updateRoleEmployee({
							name: this.addBody.name,
							mobile: this.addBody.mobile,
							uuid: this.addBody.uuid,
							avatar: this.images[0]
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					EmployeeDetail: async (uuid) => {
						const {
							data,
							status
						} = await EmployeeDetail(uuid)
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.avatar != null) {
							this.images.push(data.result.avatar)
						}
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().EmployeeDetail(val.uuid)
				} else {
					this.addBody.uuid = ''
					this.addBody.name = ''
					this.addBody.mobile = ''
					this.images = []
				}
				this.addBody.role_uuid = val.role_uuid
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>
